import create from 'zustand';

type Store = {
  isLineMode: boolean;
  setLineModeToggle: () => void;
  setLineModeClose: () => void;
};

/**
 * 編集モードのストア
 */
const useLineMode = create<Store>(set => ({
  isLineMode: false,
  setLineModeToggle: () => set(state => ({ isLineMode: !state.isLineMode })),
  setLineModeClose: () => set({ isLineMode: false }),
}));

export default useLineMode;